class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      this.getCartPrice();
      this.header?.reveal();
      this.open();
  }

  async getCartPrice() {
    try {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      if (!response.ok) {
        throw new Error('Something is wrong');
      }
      const cart = await response.json();
      if (!cart.items || cart.items.length === 0) {
        console.log('Empty cart, refetching...');
        return await showFreeShippingNotice();
      }
      this.configureFreeShippingNotice(cart.total_price);
    } catch (error) {
      console.error('Fetch error:', error);
    }
  }

  configureFreeShippingNotice(cartPrice) {
    if (!cartPrice) {
      return;
    }
    const cartTotal = parseFloat(cartPrice);
    const freeShippingElement = document.getElementById('cart-notification-free-shipping-notice');
    const freeShippingReachedString = freeShippingElement.getAttribute('data-amount-reached-string');
    const currencySymbol = freeShippingElement.getAttribute('data-currency-symbol');
    const freeShippingThreshold = parseFloat(freeShippingElement.getAttribute('data-threshold'));
    const amountRequired = freeShippingThreshold - cartTotal / 100;
    const percentage_amount_reached = cartTotal / freeShippingThreshold;
    const freeShippingTextString = document.getElementById('cart-notification-free-shipping-notice-text-string');
    const freeShippingProgress = document.getElementById('cart-notification-free-shipping-notice-progress');
    const freeShippingValueString = document.getElementById('cart-notification-free-shipping-value-string');

    if (!freeShippingElement || !freeShippingReachedString || !currencySymbol || !freeShippingThreshold || !amountRequired || !percentage_amount_reached || !freeShippingTextString || !freeShippingProgress || !freeShippingValueString) {
      return;
    }

    if (amountRequired > 0) {
      freeShippingValueString.innerHTML = currencySymbol + amountRequired.toFixed(2);
      freeShippingProgress.setAttribute('value', percentage_amount_reached)
    } else {
      freeShippingTextString.innerHTML = freeShippingReachedString;
      freeShippingProgress.setAttribute('value', 100)
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
